function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconmonstrMediaControl49(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.35 18.5h-2.6v-13h2.6zm3.9-13h-2.6v13h2.6z",
    style: {
      fill: "#fff",
      fillopacity: 1,
      stroke: "none",
      strokeWidth: 0.64999998
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconmonstrMediaControl49);
export default __webpack_public_path__ + "static/media/iconmonstr-media-control-49.86e86813413c3b0e318ae27aaaff116e.svg";
export { ForwardRef as ReactComponent };